import moment from 'moment';

/**
 * Converts a date using moment() or moment.unix() based on input.
 *
 * @param {string | number | moment.Moment} value - The input date.
 * @param {boolean} momentIsTrue - true to use moment(), false for moment.unix()
 * @param {string} [dateFormat] - Optional format string.
 * @returns {string | moment.Moment}
 */

// dateConvester({value:moment(),momentIsTrue:true, dateFormat:"YYYY-MM-DD"});                         // Today
// dateConvester(value:moment(),momentIsTrue:false , dateFormat: "X");                                 // Unix timestamp

// dateConvester({value:value ,momentIsTrue: true,dateFormat: 'HH:mm a, Do MMM YYYY'});//moment date 
// dateConvester({value:value ,dateFormat: 'HH:mm a, Do MMM YYYY'});// moment.unix date 
export function dateConverter({value, momentIsTrue, dateFormat}) {
  // ✅ Allow string, number, or moment object
  const isValidInput =
    typeof value === 'string' ||
    typeof value === 'number' ||
    moment.isMoment(value);

  if (!isValidInput) return "-";

  let date;

  if (momentIsTrue) {
    const momentValue = moment.isMoment(value) ? value : moment(value);
    date = dateFormat ? momentValue.format(dateFormat) : momentValue;
  } else {
    const unixValue = moment.isMoment(value) ? value.unix() : value;
    date = dateFormat ? moment.unix(unixValue).format(dateFormat) : moment.unix(unixValue);
  }

  return date;
}
